import { Icons } from '@commenda/kakashi';

const getPaymentMethodIcon = (brand: string) => {
  const brandMap: Record<string, React.ComponentType> = {
    mastercard: Icons.Mastercard,
    visa: Icons.Visa,
    alfabank: Icons.AlfaBank,
    americanexpress: Icons.AmericanExpress,
  };

  const IconComponent = brandMap[brand.toLowerCase()];
  return IconComponent ? <IconComponent /> : <Icons.Visa />; // TODO: Will replace Icons.Visa to a default icon - will check with designers
};

export const PaymentMethodIcon = ({ brand }: { brand: string }) => {
  return (
    <div className="w-[58px] h-[40px] flex items-center justify-center rounded-md bg-gray-50">
      {getPaymentMethodIcon(brand)}
    </div>
  );
};
